import { hashTagsService } from "motw_core/Services/HashTagsService";
import * as React from "react";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { DreamEditor } from "../DreamEditor";
import { HandleDreamEditorHashtagClicked } from "./HandleDreamEditorHashtagClicked";

export function DreamEditorHashTagLink({
    hashTag,
    DreamEditor,
    chevronPanelId,
}: {
    hashTag: string;
    DreamEditor: DreamEditor;
    chevronPanelId: string;
}) {
    const doesDreamHaveHashTag = hashTagsService.DoesDreamHaveHashTag(
        DreamEditor.state.dream,
        hashTag
    );

    const className = doesDreamHaveHashTag
        ? hasHashTagStyleClass
        : doesNotHaveHashTagStyleClass;

    return (
        <span className={className}>
            <Hyperlink
                whenClicked={() =>
                    HandleDreamEditorHashtagClicked(
                        DreamEditor,
                        hashTag,
                        chevronPanelId
                    )
                }
            >
                {hashTag}
            </Hyperlink>
        </span>
    );
}

const hasHashTagStyleClass = StyleClassAuto({
    margin: "2px 2px",
    border: `1px solid yellowgreen`,
    padding: "5px",
    borderRadius: "4px",
});

const doesNotHaveHashTagStyleClass = StyleClassAuto({
    margin: "2px 2px",
    border: `1px dotted silver`,
    padding: "5px",
    borderRadius: "4px",
    opacity: 0.8,
});
